import { useContext } from 'react';

import { SidebarContext } from '../../PageLayout/ContextProvider';
import { ContentTypes } from './constants';
import { useCurrentLegInfo } from './useCurrentLegInfo';

export const useAdditionalInfoContent = () => {
    const {
        sidebarVisibility: { additionalInfoSidebar: { contentType } = {} },
    } = useContext(SidebarContext);

    const { crewType, currentLegInfo, plnName } = useCurrentLegInfo();
    const { title = '', component: Component } = ContentTypes[contentType] || {};

    return { Component, contentType, crewType, currentLegInfo, plnName, title };
};
